<template>
  <main>
    <SectionHero :variant="hero.variant">
      <OrganismHero :hero="hero" />
    </SectionHero>
    <SectionDefault>
      <Builder :blocks="blocks" :context="context" />
    </SectionDefault>
  </main>
</template>

<script>
import Builder from '../../components/builder/Builder'
import SectionDefault from '../../components/templates/layouts/SectionDefault'
import pageBuilder from '../../components/mixins/pageBuilder.js'
import SectionHero from '../../components/templates/layouts/SectionHero'
import OrganismHero from '../../components/organisms/layouts/OrganismHero'

const mixinPageBuilder = pageBuilder({
  pageUrl: 'services',
})

export default {
  name: 'WellnessServices',
  components: {
    Builder,
    SectionDefault,
    OrganismHero,
    SectionHero,
  },
  mixins: [mixinPageBuilder],
  props: ['context'],
  meta: {
    theme: 'dark',
  },
  data: c => {
    return {
      hero: {
        variant: 'transparent-parallax',
        title1: 'Wellness-',
        title2: 'Услуги',
        hideDesc: '-md:hidden',
        desc: 'Мы предлагаем самые эффективные тестирования, чекапы, программы питания и витаминно-минеральные комплексы, которые решают ваши индивидуальные задачи и помогают подарить здоровое и счастливое долголетие.',
        image: 'fitness/uslugi/hero.webp',
        imageWrap: 'img-border-0',
        imagePosition: '!object-top',
        imageMobile: 'fitness/uslugi/hero-mobile.png',
      },
    }
  },
  head() {
    return {
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'Service',
            name: 'Wellness-услуги',
            description:
              'Мы предлагаем самые эффективные тестирования, чекапы, программы питания и витаминно-минеральные комплексы, которые решают ваши индивидуальные задачи.',
            provider: {
              '@type': 'Organization',
              name: 'Encore Fitness',
              url: 'https://encorefitness.ru/',
            },
          },
        },
      ],
    }
  },
}
</script>
